import 'reflect-metadata';
import { jsonMember, jsonObject } from 'typedjson';
import PaginationMeta from '../Pagination/PaginationModel';

@jsonObject()
export default class MetaModel {
	@jsonMember(PaginationMeta)
	public pagination: PaginationMeta = new PaginationMeta();
}
